import { isNumber } from '~/lib/math';
export const renderHighlights = (highlights, webViewer) => {
    const { annotationManager, Annotations, documentViewer } = webViewer.Core;
    const Quad = webViewer.Core.Math.Quad;
    const oldAnnots = annotationManager.getAnnotationsList();
    annotationManager.deleteAnnotations(oldAnnots.filter(a => a.Subject === 'Highlight'), { force: true });
    let first = true;
    highlights.forEach(highlight => {
        const { x1: rgx1, y1: rgy1, x2: rgx2, y2: rgy2 } = highlight.coordinates;
        const { pageNum: pageNumber } = highlight;
        if (!isNumber(pageNumber)) {
            window.debugLogger('Cannot render highlight due to invalid page number: ' +
                pageNumber);
            return;
        }
        const pageWidth = Math.floor(documentViewer.getPageWidth(pageNumber));
        const pageHeight = Math.floor(documentViewer.getPageHeight(pageNumber));
        const x1 = Math.floor(rgx1 * pageWidth);
        const y1 = Math.floor(rgy1 * pageHeight);
        const x2 = Math.floor(rgx2 * pageWidth);
        const y2 = Math.floor(rgy2 * pageHeight);
        const anno = new Annotations.TextHighlightAnnotation({
            PageNumber: pageNumber,
            Quads: [new Quad(x1, y2, x2, y2, x2, y1, x1, y1)],
            StrokeColor: new Annotations.Color(255, 255, 0),
            ReadOnly: true,
        });
        annotationManager.addAnnotation(anno);
        annotationManager.drawAnnotations({ pageNumber });
        if (first) {
            first = false;
            annotationManager.jumpToAnnotation(anno);
        }
    });
};
